export default __webpack_public_path__ + "3b242a94dd5608a06f0f1ec12d1190af.jpg";